import { render, staticRenderFns } from "./HeroImage.vue?vue&type=template&id=dca0b7ec&scoped=true"
import script from "./HeroImage.vue?vue&type=script&lang=js"
export * from "./HeroImage.vue?vue&type=script&lang=js"
import style0 from "./HeroImage.vue?vue&type=style&index=0&id=dca0b7ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca0b7ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dca0b7ec')) {
      api.createRecord('dca0b7ec', component.options)
    } else {
      api.reload('dca0b7ec', component.options)
    }
    module.hot.accept("./HeroImage.vue?vue&type=template&id=dca0b7ec&scoped=true", function () {
      api.rerender('dca0b7ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/home/components/HeroImage.vue"
export default component.exports